import LoadDocument from './LoadDocument'

export default LoadDocument
